// ============================================================================
// MarketTopBar — шапка экранов витрины (мобильный app-bar).
// НЕ UniversalWindow и НЕ окно платформы: приложение рисует собственный
// интерфейс (одна колонка, крупные касания, без таблиц/1С-форм).
// ============================================================================

import type { ReactNode } from 'react';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { useI18n } from '@/lib/i18n/I18nProvider';

interface MarketTopBarProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  action?: ReactNode;
}

export function MarketTopBar({ title, subtitle, onBack, action }: MarketTopBarProps) {
  const { t } = useI18n();
  return (
    <header className="shrink-0 border-b bg-background/95 backdrop-blur px-3 py-2.5">
      <div className="mx-auto flex w-full max-w-2xl items-center gap-2">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            aria-label={t('market.back')}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        ) : (
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Sparkles className="h-4 w-4" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-semibold leading-5">{title}</div>
          {subtitle && <div className="truncate text-[11px] leading-4 text-muted-foreground">{subtitle}</div>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
    </header>
  );
}
